import { Controller } from "@hotwired/stimulus"

// Live listing preview. The server owns rendering entirely: on input the form is submitted to the
// preview action via a submit button that overrides formaction/formmethod, and the response
// replaces the preview turbo-frame with the same partial the real placements use.
//
// The logo needs no client-side handling — Active Storage direct upload means the blob already
// exists server-side and its signed id travels with the form.
export default class extends Controller {
  static targets = ["previewButton"]
  static values = { debounce: { type: Number, default: 300 } }

  disconnect() {
    window.clearTimeout(this.timeout)
  }

  refresh() {
    window.clearTimeout(this.timeout)
    this.timeout = window.setTimeout(() => {
      this.element.requestSubmit(this.previewButtonTarget)
    }, this.debounceValue)
  }
}
